import { render } from "./Register.vue?vue&type=template&id=710b7dc9&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=710b7dc9&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/projects-manager/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710b7dc9"]])

export default __exports__